module.exports = __webpack_public_path__ + "32dd885908a27a143e316f4c99525e6a.pdf";